/* eslint-disable arrow-parens */
import { StatusCodes } from "http-status-codes";
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
const { post, get, patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "auth";

export const generatePasswordLink = async (_payload) => {
	try {
		// const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/forget-password/get-token`;
		const response = await post(endpoint, _payload, headers);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Incorrect Type Provided!") {
				alert("Incorrect Type Provided!");
			} else if (message === MESSAGE.post.fail) {
				alert("Failed to Send Mail!");
			} else alert("Other Errors of Status Code 400");
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			if (message === "Authentication Failed!") {
				alert("Authentication Failed!");
				// throw error;
			} else {
				throw error;
				//alert("Other Errors of Status Code 401");
			}
		} else if (error.response.status === StatusCodes.NOT_FOUND) {
			const { message } = error.response.data;

			if (message === "No Member Found With given information") {
				alert("No Member Found With given information");
				// throw error;
			} else {
				throw error;
				//alert("Other Errors of Status Code 401");
			}
		} else {
			throw error;
		}
	}
};

export const changeForgetPassword = async (_payload, token) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/forget-password/verify-token/${token}`;
		const response = await post(endpoint, payload, headers);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "Password has been changed successfully!") {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Unauthorised Role!") {
				alert("Unauthorised Role!");
			} else if (message === MESSAGE.none) {
				alert("No Such Data!");
			} else if (message === "New password cannot be same as old password!") {
				alert("New password cannot be same as old password!");
			} else if (message === "Timeout!") {
				alert("Timeout!");
			} else alert("Other Errors of Status Code 400");
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			if (message === "New password cannot be same as old password!") {
				alert("New password cannot be same as old password!");
				// throw error;
			} else if (error.response.status === StatusCodes.NOT_FOUND) {
				const { message } = error.response.data;

				if (message === "No Member Found With given information") {
					alert("No Member Found With given information");
					// throw error;
				} else {
					throw error;
					//alert("Other Errors of Status Code 401");
				}
			} else {
				throw error;
				//alert("Other Errors of Status Code 401");
			}
		} else {
			throw error;
		}
	}
};
